import './App.css';
import Router from './components/Router'
import Context from './components/Context'

function App() {

  return(
    <>
      <Router />
    </>
  )
}

export default App;
